<template>
  <div class="arch reveal" v-reveal>
    <div class="arch-rows">
      <div
        v-for="(layer, li) in layers"
        :key="li"
        class="arch-row"
        :style="{ '--accent': layer.color }"
      >
        <div class="arch-label">
          <span class="arch-index">0{{ li + 1 }}</span>
          <span class="arch-name">{{ layer.layer }}</span>
        </div>
        <div class="arch-items">
          <span v-for="(it, i) in layer.items" :key="i" class="arch-chip">{{ it }}</span>
        </div>
      </div>

      <!-- 层间数据流 -->
      <div class="arch-flow" aria-hidden="true">
        <span v-for="i in 3" :key="i" class="flow-dot" :style="{ animationDelay: `${i * 0.45}s` }"></span>
        <span v-for="i in 3" :key="`b${i}`" class="flow-dot flow-dot-2" :style="{ animationDelay: `${i * 0.45 + 0.3}s` }"></span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 端-边-云 / 业务-平台-支撑 分层架构图（纯 CSS 绘制，无外部依赖）
 */
export default {
  name: 'ArchDiagram',
  props: {
    layers: { type: Array, required: true }
  }
}
</script>

<style lang="scss" scoped>
.arch { position: relative; }

.arch-rows {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 26px;
}

.arch-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 20px 24px;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: linear-gradient(100deg, rgba(15, 30, 58, 0.9), rgba(8, 17, 36, 0.72));
  transition: border-color 0.4s, transform 0.4s, box-shadow 0.4s;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 12%;
    bottom: 12%;
    width: 3px;
    border-radius: 3px;
    background: var(--accent);
    box-shadow: 0 0 14px var(--accent);
  }

  &:hover {
    transform: translateX(4px);
    border-color: color-mix(in srgb, var(--accent) 45%, transparent);
    box-shadow: 0 0 34px -12px var(--accent);
  }
}

.arch-label {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 120px;

  .arch-index {
    font-size: 12px;
    letter-spacing: 0.1em;
    color: var(--accent-txt);
    font-weight: 700;
  }

  .arch-name {
    font-size: 16px;
    font-weight: 700;
    color: var(--txt);
    white-space: nowrap;
  }
}

.arch-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex: 1;
}

.arch-chip {
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13.5px;
  color: var(--txt-2);
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(120, 176, 255, 0.12);
  transition: all 0.3s;

  &:hover {
    color: #fff;
    border-color: var(--accent);
    background: rgba(255, 255, 255, 0.08);
  }
}

.arch-flow {
  position: absolute;
  left: 24px;
  right: 24px;
  top: 0;
  bottom: 0;
  pointer-events: none;
}

.flow-dot {
  position: absolute;
  left: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--grad-main);
  box-shadow: 0 0 12px rgba(34, 224, 255, 0.9);
  animation: flow 3.2s linear infinite;
}
.flow-dot-2 { animation-duration: 4.4s; animation-delay: 0.8s; opacity: 0.55; }

@keyframes flow {
  0% { top: 6%; opacity: 0; }
  15% { opacity: 1; }
  85% { opacity: 1; }
  100% { top: 92%; opacity: 0; }
}

@media (max-width: 860px) {
  .arch-row { flex-direction: column; align-items: flex-start; gap: 14px; padding: 18px; }
  .arch-label { min-width: 0; }
  .flow-dot { display: none; }
}
</style>
